import RespondentsListingPanel from "./respondentsListingPanel.container";

export default RespondentsListingPanel;